/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDocumentsubtype } from '../models/work-documentsubtype';

@Injectable({ providedIn: 'root' })
export class WorkDocumentsubtypesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentsubtypesV1ControllerGetByDocumenttypeId()` */
  static readonly DocumentsubtypesV1ControllerGetByDocumenttypeIdPath = '/v1/documentsubtypes/byDocumenttypeId/{documenttypeId}';

  /**
   * Required permissions: users:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsubtypesV1ControllerGetByDocumenttypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV1ControllerGetByDocumenttypeId$Response(
    params: {
      documenttypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocumentsubtype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsubtypesService.DocumentsubtypesV1ControllerGetByDocumenttypeIdPath, 'get');
    if (params) {
      rb.path('documenttypeId', params.documenttypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocumentsubtype>>;
      })
    );
  }

  /**
   * Required permissions: users:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsubtypesV1ControllerGetByDocumenttypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsubtypesV1ControllerGetByDocumenttypeId(
    params: {
      documenttypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocumentsubtype>> {
    return this.documentsubtypesV1ControllerGetByDocumenttypeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocumentsubtype>>): Array<WorkDocumentsubtype> => r.body)
    );
  }

}
